import { useState, useCallback } from 'react';

import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';
import { TooltipProvider } from '../../ui/Tooltip';
import { SidebarToggleContext } from './sidebarToggle';
import { UpdateSnackbar } from '../../components/UpdateSnackbar';

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const openSidebar = useCallback(() => setSidebarOpen(true), []);

  return (
    <TooltipProvider delayDuration={250}>
      <SidebarToggleContext.Provider value={openSidebar}>
        <div className="flex h-screen w-full overflow-hidden bg-background-secondary">
          <Sidebar open={sidebarOpen} onClose={closeSidebar} />
          <div className="flex h-full flex-1 flex-col overflow-hidden">
            <Topbar onMenuClick={openSidebar} />
            <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-6">
              <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6">{children}</div>
            </main>
          </div>
          <UpdateSnackbar />
        </div>
      </SidebarToggleContext.Provider>
    </TooltipProvider>
  );
};

export default DashboardLayout;
